import { CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

// Chargé à la demande : le module graphique est de loin le plus lourd de
// l'application, les autres pages n'ont pas à le télécharger.
const ChartPage = lazy(() => import('@/modules/chart/chart-page'));

export const Route = createFileRoute('/_dashboard/dashboard/chart/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense
      fallback={
        <div className="flex h-full items-center justify-center">
          <CircularProgress size={20} />
        </div>
      }
    >
      <ChartPage />
    </Suspense>
  );
}
